import React from "react";

function formatNumber(n) {
  if (n === undefined || n === null) return "-";
  return Number(n).toLocaleString("en-IN", { maximumFractionDigits: 2 });
}

export default function PositionsTable({ positions, selected, onToggle }) {
  if (!positions || positions.length === 0) {
    return <p className="muted">No open positions. Waiting for data...</p>;
  }

  return (
    <table className="positions-table">
      <thead>
        <tr>
          <th></th>
          <th>Symbol</th>
          <th>Qty</th>
          <th>Avg Price</th>
          <th>P&amp;L</th>
        </tr>
      </thead>
      <tbody>
        {positions.map((p) => {
          const isSelected = selected.includes(p.tradingsymbol);
          const pnl = p.pnl ?? 0;
          return (
            <tr key={p.tradingsymbol} className={isSelected ? "selected-row" : ""}>
              <td>
                <input
                  type="checkbox"
                  checked={isSelected}
                  onChange={() => onToggle(p.tradingsymbol)}
                />
              </td>
              <td>{p.tradingsymbol}</td>
              <td>{p.quantity}</td>
              <td>{formatNumber(p.average_price)}</td>
              <td className={pnl >= 0 ? "pnl-positive" : "pnl-negative"}>
                {formatNumber(pnl)}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
